import axios from "@/request";
import qs from "qs";

export default {
  async fields(params: any) {
    return axios.get("bp/fields", { params });
  },
  async wjSubmitData(params: any) {
    return axios.get("bp/wj-submit-data", { params });
  },
  async wjSubmitDetail(params: any) {
    return axios.get("bp/wj-submit-detail", { params });
  },
  async bindData(params: any) {
    return axios.post("bp/bind-data", qs.stringify(params));
  },
  async unbindData(params: any) {
    return axios.post("bp/unbind-data", qs.stringify(params));
  }
};
